export default "__VITE_ASSET__b25dd906__"